module.exports = __webpack_public_path__ + "static/media/lilly.8281426b.jpg";